import { render, staticRenderFns } from "./TreeTablePerson.vue?vue&type=template&id=72f9e112&"
import script from "./TreeTablePerson.vue?vue&type=script&lang=js&"
export * from "./TreeTablePerson.vue?vue&type=script&lang=js&"
import style0 from "./TreeTablePerson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports